import React, { FunctionComponent } from 'react';
import Hint from 'src/ui/atoms/hint';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';

interface DeactivateUserSuccessModalProps {
  onClose: () => void;
}

const DeactivateUserSuccessModal: FunctionComponent<DeactivateUserSuccessModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name="deactivateUserSuccessModal.title" />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="deactivateUserSuccessModal.content" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: () => onClose(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeactivateUserSuccessModal;
